import React from 'react';
import TituloPisoDeckSintetico from '../components/sections/PisoDeckSintetico/TituloPisoDeckSintetico';
import IntroPisoDeckSintetico from '../components/sections/PisoDeckSintetico/IntroPisoDeckSintetico';
import VentajasPisoDeckSintetico from '../components/sections/PisoDeckSintetico/VentajasPisoDeckSintetico';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer'; 

const PisoDeckSinteticoPage = () => {
  return (
    <div>
      <Header />
        <TituloPisoDeckSintetico />  
        <IntroPisoDeckSintetico /> 
        <VentajasPisoDeckSintetico /> 
      <Footer />
    </div>
  );
};

export default PisoDeckSinteticoPage;